import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FileService {
  private pdfContentType = "application/pdf";

  constructor(private httpClient: HttpClient) {}

  downloadFile(data: Blob, fileName: string) {
    const url = window.URL.createObjectURL(data);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style.cssText = "display: none";
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  /**
   * Converts the given base64 to Blob.
   * This is needed in case file content is sent as a part of JSON object,
   * In this case byte[] is serialized as base64 on the server and clients
   * needs to perform manual conversion.
   * Credits to: https://stackoverflow.com/a/16245768/4538875
   * @param base64 - content of the file encoded as base64.
   * @param contentType - contentType of the file (by default is pdf).
   * @returns - file content converted to Blob.
   */
  public base64ToBlob = (base64: string, contentType: string = this.pdfContentType): Blob => {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return new Blob([bytes], { type: contentType });
  };

  /**
   * Reads the file by given path to file.
   * Can be used for reading local files.
   * @param path - relative path to file.
   * @returns - Observable with content of the file.
   */
  readFile(path: string): Observable<string> {
    return this.httpClient.get(path, { responseType: "text" });
  }
}
